/* Shared primitive recipes. Values stay in tokens.css; this file only composes roles. */
// Controls sit on the surface they live in (card/popover) — never a second grey fill.
export const controlBase =
  "min-h-[var(--ds-density-control-height)] rounded-[var(--ds-radius-control)] border border-input bg-card text-foreground text-sm shadow-[var(--shadow-control)] transition-[color,box-shadow,border-color,background-color] duration-[var(--ds-motion-duration-fast)] motion-reduce:transition-none hover:border-border-hover";

export const controlFocus =
  "outline-none focus-visible:border-ring focus-visible:ring-[length:var(--ds-focus-ring-width)] focus-visible:ring-ring/20 focus-visible:ring-offset-[var(--ds-focus-ring-offset)]";

export const buttonFocus =
  "outline-none focus-visible:border-ring focus-visible:ring-[length:var(--ds-focus-ring-width-button)] focus-visible:ring-ring/45 focus-visible:ring-offset-[length:var(--ds-focus-ring-offset)] focus-visible:ring-offset-background";

export const controlDisabled =
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50";

export const menuSurface =
  "rounded-[var(--ds-radius-surface)] border border-border bg-popover text-popover-foreground shadow-[var(--shadow-popover)]";

export const tooltipSurface =
  "rounded-[var(--ds-radius-control)] border border-border bg-popover text-popover-foreground shadow-[var(--shadow-popover)]";

// cmdk emits data-disabled="false" on enabled items; ARIA state also works for Radix.
export const menuItem =
  "relative flex cursor-default select-none items-center rounded-[var(--ds-radius-control-compact)] text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground aria-disabled:pointer-events-none aria-disabled:opacity-50";

export const overlaySurface =
  "rounded-[var(--ds-radius-workbench)] border border-border bg-card text-card-foreground shadow-[var(--shadow-command)]";

export const overlayBackdrop =
  "fixed inset-0 bg-[var(--ds-overlay-backdrop)] backdrop-blur-[var(--ds-overlay-backdrop-blur)]";

export const iconButton =
  "inline-flex size-[var(--ds-density-icon-button-size)] shrink-0 items-center justify-center rounded-[var(--ds-radius-control)] outline-none transition-colors focus-visible:border-ring focus-visible:ring-[length:var(--ds-focus-ring-width)] focus-visible:ring-ring/40 focus-visible:ring-offset-[var(--ds-focus-ring-offset)] focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50";

export const editorFrame =
  "flex flex-col rounded-[var(--ds-radius-control)] border border-input transition-[border-color,box-shadow] duration-[var(--ds-motion-duration-fast)] motion-reduce:transition-none focus-within:border-ring focus-within:ring-[length:var(--ds-focus-ring-width)] focus-within:ring-ring/20";

export const editorToolbar =
  "flex shrink-0 flex-wrap gap-[var(--ds-space-1)] border-b border-border-subtle p-[var(--ds-space-2)]";
